import React, { useState, useEffect, useRef } from 'react';
import styles from './WhyGepdec.module.css';

const WhyGepdec = () => {
    const [currentStat, setCurrentStat] = useState(0);
    const sectionRef = useRef(null);
    const [isInView, setIsInView] = useState(false);

    const statistics = [
        {
            id: 1,
            number: "98%",
            label: "on time deliveries",
            color: "#ffffff"
        },
        {
            id: 2,
            number: "GIS Substations",
            label: "(400kV/220kV/132kV/33kV)",
            color: "#ffffff"
        },
        {
            id: 3,
            number: "12+",
            label: "years of experience",
            color: "#3b82f6"
        },
        {
            id: 4,
            number: "50+",
            label: "satisfied clients",
            color: "#3b82f6"
        },
        {
            id: 5,
            number: "ISO 9001:2008",
            label: "certified company",
            color: "#ffffff"
        }
    ];

    useEffect(() => {
        const handleScroll = () => {
            if (!sectionRef.current) return;

            const section = sectionRef.current;
            const rect = section.getBoundingClientRect();
            const sectionHeight = section.offsetHeight;
            const windowHeight = window.innerHeight;

            // Check if section is in view
            if (rect.top <= windowHeight && rect.bottom >= 0) {
                setIsInView(true);

                // Calculate scroll progress within the section
                const scrollProgress = Math.max(0, Math.min(1,
                    (windowHeight - rect.top) / (sectionHeight + windowHeight)
                ));

                // Determine which statistic to show based on scroll progress
                const statIndex = Math.min(
                    statistics.length - 1,
                    Math.floor(scrollProgress * statistics.length)
                );

                setCurrentStat(statIndex);
            } else {
                setIsInView(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Initial call

        return () => window.removeEventListener('scroll', handleScroll);
    }, [statistics.length]);

    const currentStatistic = statistics[currentStat];

    return (
        <section className={styles.whyGepdecSection} ref={sectionRef}>
            <div className={styles.container}>
                <div className={styles.content}>
                    {/* Fixed Left Content */}
                    <div className={styles.leftContent}>
                        <div className={styles.titleContainer}>
                            <h2 className={styles.mainTitle}>
                                <span className={styles.titleWhite}>Why </span>
                                <span className={styles.titleGreen}>Choose Us</span>
                            </h2>
                        </div>

                        <div className={styles.description}>
                            <ul className={styles.descriptionText}>
                                <li>Proven Expertise in High-Voltage EPC Projects</li>
                                <li>Innovation Driven by Strategic Partnerships</li>
                                <li>Excellence in Executing Complex Projects</li>
                                <li>Strong Scalability with a Robust Project Pipeline</li>
                                <li>Highly Experienced Team of Professionals</li>
                            </ul>
                        </div>
                    </div>

                    {/* Scrollable Right Content */}
                    <div className={styles.rightContent}>
                        <div className={styles.statisticContainer}>
                            <div
                                className={styles.statisticNumber}
                                style={{ color: currentStatistic.color }}
                                key={currentStat} // Force re-render for animation
                            >
                                {currentStatistic.number}
                            </div>
                            <div className={styles.statisticLabel}>
                                {currentStatistic.label}
                            </div>
                        </div>

                        {/* Progress Indicators */}
                        {/* <div className={styles.progressIndicators}>
                            {statistics.map((_, index) => (
                                <div
                                    key={index}
                                    className={`${styles.indicator} ${
                                        index === currentStat ? styles.indicatorActive : ''
                                    }`}
                                />
                            ))}
                        </div> */}
                    </div>
                </div>
            </div>

            {/* Background Pattern */}
            <div className={styles.backgroundPattern}>
                <div className={styles.gridPattern}></div>
            </div>
        </section>
    );
};

export default WhyGepdec;
